function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from "react";
import PropTypes from "prop-types";
import * as Sentry from "@sentry/react";
import { ContextPropTypes, withFeedback } from "@dpdgroupuk/react-sentry-feedback";
import ErrorAlert from "./ErrorAlert";

class ErrorBoundary extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "onCloseReportFeedbackDialog", () => {
      window.location.reload();
    });

    _defineProperty(this, "onReportFeedbackClick", () => {
      const {
        eventId
      } = this.state;
      this.props.feedback.showReportDialog({
        eventId,
        onClose: this.onCloseReportFeedbackDialog
      });
    });

    this.state = {
      eventId: null,
      error: null
    };
  }

  componentDidCatch(error, info) {
    Sentry.withScope(scope => {
      scope.setExtras(info);
      const eventId = Sentry.captureException(error);
      this.setState({
        eventId,
        error
      });
    });
  }

  render() {
    const {
      component: Component,
      feedback,
      children,
      ...props
    } = this.props;

    if (this.state.error) {
      const onReportFeedbackClick = process.env.NODE_ENV === "production" ? this.onReportFeedbackClick : null;
      return /*#__PURE__*/React.createElement(Sentry.ErrorBoundary, {
        fallback: /*#__PURE__*/React.createElement(Component, _extends({
          error: this.state.error,
          onReportFeedbackClick: onReportFeedbackClick
        }, props))
      }, children);
    }

    return children;
  }

}

ErrorBoundary.defaultProps = {
  component: ErrorAlert
};
ErrorBoundary.propTypes = {
  children: PropTypes.node,
  component: PropTypes.elementType.isRequired,
  feedback: ContextPropTypes
};
export default withFeedback(ErrorBoundary);